import React from 'react';
import { modes } from '@comall-backend-builder/types';

/**
 * 标题类型
 */
export class TitleMode extends modes.StringMode {
    /**
     * 获取展示组件
     */
    getAvailableDisplayComponent(value: any) {
        return <h1 className="format-string mode-title">{value}</h1>;
    }
}
